import React, { useState, useEffect } from "react";
import ElementModal from "../modal/elementModal";
import {
  getAllElements,
  deleteElement,
  getAllSearchElements,
  getPageRefDetail,
} from "../../api/api";

import Listloader from "../loader/content";
import InfiniteScroll from "react-infinite-scroll-component";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import "../pages/search.css";
import Loader from "../loader/loader";
import { Link } from "react-router-dom";
import { UserLang } from "../../store/userStore";
import ItemModals from "../modal/itemModel2";

const Elements = (props) => {
  let pager = "page";
  const [itemModalShow, setitemModalShow] = useState(false);
  const [delModalShow, setDelModalShow] = useState(false);
  const [allElem, setallElem] = useState([]);
  const [elemNum, setelemNum] = useState(0);
  const [haslot, sethasLot] = useState(true);
  const [query, setQuery] = useState("");
  const [search, setSearch] = useState(false);
  const [loading, setLoading] = useState(false);
  const [listload, setListload] = useState(true);
  const [elemId, setElemId] = useState([]);
  const lan = UserLang.useState((s) => s.lan);

  useEffect(() => {
    const getElements = async () => {
      try {
        setLoading(true);
        const appl = await getAllElements(10, 0);

        const pages = appl.data.elements;

        const imageCount = appl.data.count;

        setallElem(pages);
        setelemNum(imageCount);
        if (imageCount === appl.data.elements.length) {
          sethasLot(false);
        }
        setLoading(false);
      } catch (error) {}
    };
    getElements();
  }, []);

  const handleDelete = async (event, id, index) => {
    if (id !== undefined && id !== "") {
      /* eslint-disable no-unused-vars */
      const result = await getPageRefDetail(id).then(
        (result) => {
          setElemId(result.data);
          setListload(false);
          if (result.data.length > 0) {
            setDelModalShow(true);
          } else {
            setDelModalShow(false);
            const removeId = index;
            event.preventDefault();
            const items = Array.from(allElem);
            items.splice(removeId, 1);
            setallElem(items);
            try {
              /* eslint-disable no-unused-vars */
              const result = deleteElement(id);
              /* eslint-disable no-unused-vars */
              toastr.success("Successfully Deleted", "Success");
            } catch (error) {
              toastr.error("Error in deleting the Element", "Error");
            }
          }
        },
        (error) => {
          setElemId(null);
          setListload(false);
        }
      );
    } else {
      setListload(false);
      toastr.error("Delete Id is Missing", "Error");
    }
    /* eslint-disable no-unused-vars */
  };

  const fetchData = async () => {
    if (
      (!search && (query === "" || query !== "")) ||
      (search && query === "")
    ) {
      if (elemNum === allElem.length) {
        sethasLot(false);
      } else {
        const length = allElem.length;
        try {
          const appl = await getAllElements(length + 10, length);

          const pages = appl.data.elements;

          const imageCount = appl.data.count;

          setelemNum(imageCount);
          const newArray = [...allElem, ...pages];

          setallElem(newArray);
          setelemNum(imageCount);
          if (elemNum === allElem.length) {
            sethasLot(false);
          }
        } catch (error) {}
      }
    } else {
      const length = allElem.length;
      try {
        const appl = await getAllSearchElements(length + 10, length, query);

        const pages = appl.data.elements;

        const imageCount = appl.data.count;

        setelemNum(imageCount);
        const newArray = [...allElem, ...pages];

        setallElem(newArray);
        setelemNum(imageCount);
        if (elemNum === allElem.length) {
          sethasLot(false);
        }
      } catch (error) {}
    }
  };

  const getSearchResult = async () => {
    setLoading(true);

    try {
      const appl = await getAllSearchElements(10, 0, query);
      const pages = appl.data.elements;

      const imageCount = appl.data.count;

      setallElem(pages);
      setelemNum(imageCount);
      if (imageCount === appl.data.elements.length) {
        sethasLot(false);
      }
      if (appl.data.elements.length < appl.data.limit) {
        sethasLot(false);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const getElementStart = async () => {
    setLoading(true);
    sethasLot(true);
    try {
      const appl = await getAllElements(10, 0);

      const pages = appl.data.elements;

      const imageCount = appl.data.count;

      setallElem(pages);
      setelemNum(imageCount);
      if (imageCount === appl.data.elements.length) {
        sethasLot(false);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  if (loading) {
    return (
      <div className="content">
        <Loader />
      </div>
    );
  } else {
    return (
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-header filter">
                  <h3
                    className={
                      lan === "rtl"
                        ? "card-title float-right"
                        : "card-title float-left"
                    }
                  >
                    Elements
                  </h3>
                  <ul
                    className={
                      lan === "rtl"
                        ? "float-left navbar-nav ml-auto "
                        : "float-right navbar-nav ml-auto "
                    }
                  >
                    <li className="nav-item">
                      <a
                        className="nav-link"
                        data-widget="navbar-search"
                        href="#!"
                        role="button"
                        onClick={(event) => {
                          event.preventDefault();
                          setSearch(!search);
                        }}
                      >
                        <i className="fas fa-search"></i>
                      </a>
                      <div
                        className={
                          search
                            ? "navbar-search-block"
                            : "navbar-search-block none"
                        }
                      >
                        <form
                          className="form-inline"
                          onSubmit={(event) => {
                            event.preventDefault();
                            getSearchResult();
                          }}
                        >
                          <div className="input-group input-group-sm">
                            <input
                              className="form-control form-control-navbar"
                              type="search"
                              placeholder="Search"
                              aria-label="Search"
                              value={query}
                              onChange={(event) => setQuery(event.target.value)}
                            />
                            <div className="input-group-append">
                              <button className="btn btn-navbar" type="submit">
                                <i className="fas fa-search"></i>
                              </button>
                              <button
                                className="btn btn-navbar"
                                type="button"
                                data-widget="navbar-search"
                                onClick={(event) => {
                                  setSearch(false);
                                  getElementStart();
                                }}
                              >
                                <i className="fas fa-times"></i>
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </li>
                    <li className="nav-item">
                      <a
                        href="#!"
                        className="nav-link btn btn-light"
                        role="button"
                        onClick={() => setitemModalShow(true)}
                      >
                        <i className="fas fa-plus"></i> New
                      </a>
                    </li>
                  </ul>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <div className="row" style={{ marginTop: "10px" }}>
                          <div className="col-sm-12">
                            <InfiniteScroll
                              dataLength={allElem.length}
                              hasMore={haslot}
                              loader={<Listloader></Listloader>}
                              next={fetchData}
                            >
                              <table
                                id="appadmin"
                                className="table table-bordered table-hover dataTable dtr-inline"
                                role="grid"
                                aria-describedby="example2_info"
                                dir={lan === "rtl" ? "rtl" : "ltr"}
                              >
                                <thead>
                                  <tr role="row">
                                    <th
                                      className="sorting_asc"
                                      tabIndex={0}
                                      aria-controls="example2"
                                      rowSpan={1}
                                      colSpan={1}
                                    >
                                      <label
                                        className={
                                          lan === "rtl"
                                            ? "float-right"
                                            : "float-left"
                                        }
                                      >
                                        Name
                                      </label>
                                    </th>
                                    <th>
                                      <label
                                        className={
                                          lan === "rtl"
                                            ? "float-right"
                                            : "float-left"
                                        }
                                      >
                                        Status
                                      </label>
                                    </th>
                                    <th
                                      className="sorting"
                                      tabIndex={0}
                                      aria-controls="example2"
                                      rowSpan={1}
                                      colSpan={1}
                                    >
                                      <label
                                        className={
                                          lan === "rtl"
                                            ? "float-right"
                                            : "float-left"
                                        }
                                      >
                                        Delete
                                      </label>
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {allElem.map((person, index) => (
                                    <tr role="row" className="even" key={index}>
                                      <td
                                        className="dtr-control sorting_1"
                                        tabIndex={0}
                                      >
                                        <Link
                                          to={
                                            person.elementType === "tabItem"
                                              ? "/tab/" + person._id
                                              : person.elementType ===
                                                  "textGrid"
                                                ? "/textGrid/" + person._id
                                                : person.elementType ===
                                                    "highlightTextGrid"
                                                  ? "/highlightTextGrid/" +
                                                    person._id
                                                  : person.elementType === "epg"
                                                    ? "/epg/" + person._id
                                                    : person.elementType ===
                                                        "embed"
                                                      ? "/embed/" + person._id
                                                      : person.elementType ===
                                                          "gallery"
                                                        ? "/item/gallery/" +
                                                          person._id
                                                        : "/item/" +
                                                          person.elementType +
                                                          "/" +
                                                          person._id
                                          }
                                          style={{ display: "block" }}
                                          className={
                                            lan === "rtl"
                                              ? "float-right"
                                              : "float-left"
                                          }
                                        >
                                          {person.referenceName}
                                        </Link>
                                        <br></br>
                                        <span
                                          className={
                                            lan === "rtl"
                                              ? "float-right text-muted"
                                              : "float-left text-muted"
                                          }
                                        >
                                          {person.elementType}
                                        </span>
                                      </td>
                                      <td>
                                        <label
                                          className={
                                            lan === "rtl"
                                              ? person.draftStatus &&
                                                person.publishStatus
                                                ? "badge badge-success float-right"
                                                : "badge badge-danger float-right"
                                              : person.draftStatus &&
                                                  person.publishStatus
                                                ? "badge badge-success float-left"
                                                : "badge badge-danger float-left"
                                          }
                                        >
                                          {person.draftStatus &&
                                          person.publishStatus
                                            ? "Published"
                                            : "Draft"}
                                          {}
                                        </label>
                                      </td>
                                      <td>
                                        <button
                                          type="button"
                                          className={
                                            lan === "rtl"
                                              ? "float-right btn btn-light"
                                              : "float-left btn btn-light"
                                          }
                                          onClick={(event) =>
                                            handleDelete(
                                              event,
                                              person._id,
                                              index
                                            )
                                          }
                                        >
                                          <i className="fa fa-trash"></i> Delete
                                        </button>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </InfiniteScroll>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /.card-body */}
              </div>
            </div>
          </div>
        </div>

        <ElementModal
          show={delModalShow}
          onHide={() => setDelModalShow(false)}
          elemid={!listload ? elemId : null}
          paged={pager === "page" ? 1 : 0}
        ></ElementModal>
        <ItemModals
          show={itemModalShow}
          onHide={() => setitemModalShow(false)}
          {...props}
        />
      </section>
    );
  }
};

export default Elements;
